import { render, staticRenderFns } from "./aishortSign.vue?vue&type=template&id=5d0c542e&scoped=true"
import script from "./aishortSign.vue?vue&type=script&lang=js"
export * from "./aishortSign.vue?vue&type=script&lang=js"
import style0 from "./aishortSign.vue?vue&type=style&index=0&id=5d0c542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c542e",
  null
  
)

export default component.exports